export default __webpack_public_path__ + "static/media/knotLogoMain2.b72c5601.png";